// const API_BASE_URL = 'http://api.cityflowerksa.com'
// const API_STORAGE_URL = 'http://api.cityflowerksa.com'
// const API_BASE_URL = 'https://staging.kabayanhypermarkets.com'
// const API_STORAGE_URL = 'https://staging.kabayanhypermarkets.com'
const API_BASE_URL = 'https://app.kabayanhypermarkets.com'
const API_STORAGE_URL = 'https://app.kabayanhypermarkets.com'

// const API_BASE_URL = 'http://127.0.0.1:8000'
// const API_STORAGE_URL = 'http://127.0.0.1:8000'

const NAME = 'Kabayan Rewards'
const GOOGLE_API_TOKEN = ''
export default {
	API_BASE_URL, NAME, GOOGLE_API_TOKEN, API_STORAGE_URL,
}
